export const BLOCK_EXPLORER = "https://mumbai.polygonscan.com";

export const TOKEN_STORAGE_KEY = "token-auth";
